import {Program} from './program';

export class Product {

  constructor(
    public id: string,
    public program?: Program,
    public displayLabel?: string,
    public status?: string,
    public timezone?: string,
    public timezone_short?: string,
    public timezone_long?: string
  ) {
  }

  static newInstance(id: string, programId?: string, displayLabel?: string, status?: string, timezone?: string, timezone_short?: string, timezone_long?: string) {
    return new Product(id, new Program(programId), displayLabel, status, timezone, timezone_short, timezone_long);
  }

  clone(): Product {
    return new Product(this.id, this.program, this.displayLabel, this.status, this.timezone, this.timezone_short, this.timezone_long);
  }

}
